<div
    style=" background-color: #F3F3F5;width: 100%; height: auto; display: flex; justify-content: flex-end; padding: 0; margin: 0;">
    <button class="close-button" mat-dialog-close>
        <img src="./assets/images/close-icon.svg">
    </button>
</div>


<mat-dialog-content class="box-share-content">
    <div class="main-box-title-32" style="margin-bottom: 25px ;" *ngIf="!isEditing"> Create Wordlist</div>
    <div class="main-box-title-32" style="margin-bottom: 25px ;" *ngIf="isEditing"> Edit Wordlist</div>
    <div>
        <div class="main-box-title-18">You can separate the words using spaces, commas, or semicolons for each one.</div>
        <div style="margin-top: 20px;">
        </div>
        <div class="main-box-title-18" style="margin-bottom: 5px ;">List Name</div>
        <div style="border: 1px solid #ccc; padding: 4px; border-radius: 4px; background-color: #f9f9f9;">
            <input type="text" class="box-input" [(ngModel)]="namewordlist">
        </div>
        <div style="margin-top: 20px;"></div>
        <div class="main-box-title-18" style="margin-bottom: 5px ;">Wordlist</div>
        <div style="border: 1px solid #ccc; padding: 4px; border-radius: 4px; background-color: #f9f9f9;">
          <input type="text" class="box-input" [(ngModel)]="wordlistInput">
        </div>
        <div style="margin-top: 40px;"></div>
    </div>

    <div class="box-button">
        <button class="cancel-btn" mat-dialog-close>
            <img class="cancel-img" src="./assets/images/yellow_icons/cancel-icon.svg">
            <span><u class="main-box-value-16-bold">Cancel</u></span>
        </button>
        <button class="analysis-button" (click)="createList()" *ngIf="!isEditing">
            <span class="main-box-title-16" style="font-weight: 600;">
                Create List</span> </button>
        <button class="analysis-button" (click)="createList()" *ngIf="isEditing">
            <span class="main-box-title-16" style="font-weight: 600;">
                Edit List</span> </button>
    </div>
</mat-dialog-content>
